
import Header from '../../components/feature/Header';
import Cases from '../../components/feature/Cases';
import Clients from '../../components/feature/Clients';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import manifest from '../../assets/images/external/manifest.json';

const externalModules = import.meta.glob('/src/assets/images/external/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });
const resolveLocal = (url: string) => {
  if (url.startsWith('https://readdy.ai') || url.startsWith('https://public.readdy.ai')) {
    const fn = (manifest as Record<string, string>)[url];
    if (fn) {
      const key = `/src/assets/images/external/${fn}`;
      const mod = externalModules[key] as any;
      if (mod) return (mod.default || mod) as string;
    }
  }
  return url;
}

export default function Home() {

  const services = [
    {
      icon: 'ri-palette-line',
      title: 'Branding',
      description: 'Creamos identidades de marca únicas que conectan emocionalmente con tu audiencia y diferencias tu negocio en el mercado.',
      features: ['Identidad Visual', 'Manual de Marca', 'Naming', 'Posicionamiento']
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Diseño e Identidad',
      description: 'Desarrollamos sistemas visuales coherentes que comunican los valores de tu marca de manera efectiva y memorable.',
      features: ['Logo Design', 'Tipografía', 'Paleta de Colores', 'Elementos Gráficos']
    },
    {
      icon: 'ri-computer-line',
      title: 'Web Design',
      description: 'Diseñamos experiencias digitales intuitivas y atractivas que convierten visitantes en clientes fieles.',
      features: ['UI/UX Design', 'Responsive Design', 'Prototipado', 'Optimización']
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Estrategia de Marca',
      description: 'Definimos estrategias integrales que posicionan tu marca de manera efectiva en el mercado objetivo.',
      features: ['Análisis de Mercado', 'Buyer Personas', 'Propuesta de Valor', 'Roadmap']
    },
    {
      icon: 'ri-gift-line',
      title: 'Packaging',
      description: 'Creamos envases que no solo protegen tu producto, sino que también comunican tu marca y atraen a los consumidores.',
      features: ['Diseño Estructural', 'Etiquetado', 'Materiales', 'Sostenibilidad']
    }
  ];

  const portfolioItems = [
    {
      title: 'TechStart Solutions',
      category: 'Branding & Web Design',
      image: 'https://readdy.ai/api/search-image?query=modern%20tech%20startup%20branding%20design%20with%20clean%20minimalist%20logo%20and%20website%20interface%2C%20professional%20corporate%20identity%2C%20blue%20and%20white%20color%20scheme%2C%20sleek%20technology%20aesthetic&width=400&height=300&seq=1&orientation=landscape'
    },
    {
      title: 'Organic Café',
      category: 'Packaging & Identidad',
      image: 'https://readdy.ai/api/search-image?query=organic%20coffee%20packaging%20design%20with%20natural%20earth%20tones%2C%20eco-friendly%20branding%2C%20coffee%20beans%20and%20leaves%2C%20sustainable%20packaging%20materials%2C%20warm%20brown%20and%20green%20colors&width=400&height=300&seq=2&orientation=landscape'
    },
    {
      title: 'Fashion Forward',
      category: 'Branding Completo',
      image: 'https://readdy.ai/api/search-image?query=luxury%20fashion%20brand%20identity%20design%20with%20elegant%20typography%2C%20sophisticated%20color%20palette%2C%20high-end%20fashion%20accessories%2C%20premium%20branding%20materials%2C%20black%20and%20gold%20aesthetic&width=400&height=300&seq=3&orientation=landscape'
    },
    {
      title: 'EcoHome Living',
      category: 'Web Design & Estrategia',
      image: 'https://readdy.ai/api/search-image?query=sustainable%20home%20products%20website%20design%20with%20clean%20green%20interface%2C%20eco-friendly%20lifestyle%20branding%2C%20natural%20materials%20and%20plants%2C%20modern%20minimalist%20web%20layout&width=400&height=300&seq=4&orientation=landscape'
    },
    {
      title: 'Artisan Bakery',
      category: 'Packaging & Branding',
      image: 'https://readdy.ai/api/search-image?query=artisan%20bakery%20branding%20with%20rustic%20packaging%20design%2C%20handcrafted%20bread%20and%20pastries%2C%20warm%20bakery%20atmosphere%2C%20traditional%20craft%20aesthetic%2C%20brown%20and%20cream%20colors&width=400&height=300&seq=5&orientation=landscape'
    },
    {
      title: 'Digital Agency Pro',
      category: 'Identidad Digital',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20agency%20branding%20with%20modern%20geometric%20patterns%2C%20vibrant%20gradient%20colors%2C%20tech-forward%20design%20elements%2C%20professional%20business%20identity%2C%20purple%20and%20cyan%20palette&width=400&height=300&seq=6&orientation=landscape'
    }
  ];

  const testimonials = [
    {
      name: 'María González',
      company: 'CEO, TechStart Solutions',
      text: 'Rebranding transformó completamente nuestra identidad visual. El resultado superó nuestras expectativas y nos ayudó a destacar en un mercado competitivo.',
      rating: 5
    },
    {
      name: 'Carlos Mendoza',
      company: 'Fundador, Organic Café',
      text: 'El equipo entendió perfectamente nuestra visión sostenible y la plasmó en un diseño de packaging excepcional que nuestros clientes adoran.',
      rating: 5
    },
    {
      name: 'Ana Rodríguez',
      company: 'Directora, Fashion Forward',
      text: 'Profesionales excepcionales. Crearon una identidad de marca que refleja perfectamente nuestros valores de lujo y elegancia.',
      rating: 5
    }
  ];

  

  return (
    <div className="min-h-screen bg-[#1a1a2e] font-['Inter']">
      <Header />
      <Clients />
      {/* Hero Section */}
      <section 
        id="inicio" 
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20creative%20design%20studio%20workspace%20with%20sleek%20computers%2C%20design%20materials%2C%20color%20palettes%2C%20and%20branding%20elements%2C%20professional%20creative%20environment%20with%20dark%20navy%20background%20and%20neon%20green%20accents%2C%20minimalist%20aesthetic&width=1920&height=1080&seq=7&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-[#1a1a2e]/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="text-white">Transformamos</span><br />
              <span className="text-[#9EFF00]">Tu Marca</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              Somos una agencia especializada en <strong>branding</strong>, <strong>diseño e identidad visual</strong> que 
              convierte ideas en marcas poderosas que conectan, comunican y convierten.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button size="lg" href="#contacto">
                <i className="ri-rocket-line mr-2"></i>
                Comenzar Mi Proyecto
              </Button>
              <Button variant="outline" size="lg" href="#portafolio">
                <i className="ri-eye-line mr-2"></i>
                Ver Nuestro Trabajo
              </Button>
            </div>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-[#9EFF00] text-2xl"></i>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="py-20 bg-[#0f0f23]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Nuestros <span className="text-[#9EFF00]">Servicios</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Ofrecemos soluciones integrales de <strong>branding</strong> y <strong>diseño</strong> que 
              impulsan el crecimiento de tu negocio y fortalecen tu presencia en el mercado.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={service.title}
                className="bg-[#1a1a2e] p-8 rounded-2xl border border-gray-800 hover:border-[#9EFF00]/30 transition-all duration-300 hover:transform hover:scale-105"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-[#9EFF00]/10 rounded-xl mb-6">
                  <i className={`${service.icon} text-2xl text-[#9EFF00]`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                <p className="text-gray-300 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-center text-gray-400">
                      <i className="ri-check-line text-[#9EFF00] mr-3"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Cases />

      {/* Portfolio Section */}
      <section id="portafolio" className="py-20 bg-[#1a1a2e]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Nuestro <span className="text-[#9EFF00]">Portafolio</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Descubre algunos de nuestros proyectos más destacados en <strong>branding</strong>, 
              <strong>diseño web</strong> y <strong>estrategia de marca</strong>.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolioItems.map((item, index) => (
              <div 
                key={item.title}
                className="group relative overflow-hidden rounded-2xl bg-[#0f0f23] border border-gray-800 hover:border-[#9EFF00]/30 transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <span className="text-[#9EFF00] text-sm font-medium">{item.category}</span>
                  <h3 className="text-xl font-bold text-white mt-2">{item.title}</h3>
                </div>
                <div className="absolute inset-0 bg-[#9EFF00]/0 group-hover:bg-[#9EFF00]/10 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <Button variant="secondary" size="sm">
                    <i className="ri-eye-line mr-2"></i>
                    Ver Proyecto
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Success Cases Section */}
      <section className="py-20 bg-[#0f0f23]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Casos de <span className="text-[#9EFF00]">Éxito</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Proyectos que transformaron marcas y generaron resultados excepcionales 
              para nuestros clientes.
            </p>
          </div>

          <div className="space-y-20">
            {/* Case Study 1 - Record Sport Café */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="mb-6">
                  <span className="text-[#9EFF00] text-sm font-medium uppercase tracking-wide">Diseño e Identidad</span>
                  <h3 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4">Record Sport Café</h3>
                  <p className="text-gray-300 text-lg leading-relaxed">
                    Rediseño estético y branding para cafetería con temática deportiva dentro de un importante centro multideportivo. 
                    Creamos una identidad visual moderna que conecta con la pasión deportiva de sus clientes.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="bg-[#1a1a2e] p-6 rounded-xl border border-gray-800">
                    <div className="text-2xl font-bold text-[#9EFF00] mb-2">+150%</div>
                    <div className="text-gray-300 text-sm">Aumento en ventas</div>
                  </div>
                  <div className="bg-[#1a1a2e] p-6 rounded-xl border border-gray-800">
                    <div className="text-2xl font-bold text-[#9EFF00] mb-2">85%</div>
                    <div className="text-gray-300 text-sm">Reconocimiento de marca</div>
                  </div>
                </div>

                <div className="space-y-4">
                  <h4 className="text-xl font-semibold text-white">Servicios Realizados:</h4>
                  <div className="flex flex-wrap gap-3">
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Identidad Visual
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Diseño de Interiores
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Señalética
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Material Promocional
                    </span>
                  </div>
                </div>
              </div>

              <div className="order-1 lg:order-2">
                <div className="relative">
                  <img 
                    src={resolveLocal("https://readdy.ai/api/search-image?query=modern%20sports%20cafe%20interior%20design%20with%20RECORD%20branding%2C%20contemporary%20coffee%20shop%20with%20sports%20theme%2C%20red%20and%20white%20color%20scheme%2C%20athletic%20memorabilia%20on%20walls%2C%20sleek%20counter%20design%2C%20professional%20commercial%20space&width=600&height=500&seq=24&orientation=landscape")}
                    alt="Record Sport Café - Caso de éxito"
                    className="rounded-2xl object-cover object-top w-full h-[500px]"
                  />
                  <div className="absolute top-6 right-6 bg-[#9EFF00] text-black px-4 py-2 rounded-lg font-semibold">
                    Caso de Éxito
                  </div>
                </div>
              </div>
            </div>

            {/* Case Study 2 - TechStart Solutions */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="relative">
                  <img 
                    src={resolveLocal("https://readdy.ai/api/search-image?query=modern%20tech%20startup%20office%20branding%20with%20clean%20minimalist%20design%2C%20professional%20corporate%20identity%20materials%2C%20blue%20and%20white%20color%20scheme%2C%20sleek%20technology%20aesthetic%2C%20business%20cards%20and%20letterheads%2C%20contemporary%20workspace&width=600&height=500&seq=25&orientation=landscape")}
                    alt="TechStart Solutions - Caso de éxito"
                    className="rounded-2xl object-cover object-top w-full h-[500px]"
                  />
                  <div className="absolute top-6 left-6 bg-[#9EFF00] text-black px-4 py-2 rounded-lg font-semibold">
                    Transformación Total
                  </div>
                </div>
              </div>

              <div>
                <div className="mb-6">
                  <span className="text-[#9EFF00] text-sm font-medium uppercase tracking-wide">Branding Completo</span>
                  <h3 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4">TechStart Solutions</h3>
                  <p className="text-gray-300 text-lg leading-relaxed">
                    Desarrollo integral de identidad corporativa para startup tecnológica. Desde el naming hasta 
                    la implementación completa de la marca en todos los puntos de contacto digitales y físicos.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="bg-[#1a1a2e] p-6 rounded-xl border border-gray-800">
                    <div className="text-2xl font-bold text-[#9EFF00] mb-2">300%</div>
                    <div className="text-gray-300 text-sm">Crecimiento en leads</div>
                  </div>
                  <div className="bg-[#1a1a2e] p-6 rounded-xl border border-gray-800">
                    <div className="text-2xl font-bold text-[#9EFF00] mb-2">$2M</div>
                    <div className="text-gray-300 text-sm">Inversión conseguida</div>
                  </div>
                </div>

                <div className="space-y-4">
                  <h4 className="text-xl font-semibold text-white">Servicios Realizados:</h4>
                  <div className="flex flex-wrap gap-3">
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Naming & Logo
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Manual de Marca
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Web Design
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Estrategia Digital
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Case Study 3 - Organic Café */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="mb-6">
                  <span className="text-[#9EFF00] text-sm font-medium uppercase tracking-wide">Packaging & Branding</span>
                  <h3 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4">Organic Café</h3>
                  <p className="text-gray-300 text-lg leading-relaxed">
                    Rediseño completo de packaging y branding para marca de café orgánico. Enfoque en sostenibilidad 
                    y conexión emocional con consumidores conscientes del medio ambiente.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="bg-[#1a1a2e] p-6 rounded-xl border border-gray-800">
                    <div className="text-2xl font-bold text-[#9EFF00] mb-2">+200%</div>
                    <div className="text-gray-300 text-sm">Ventas online</div>
                  </div>
                  <div className="bg-[#1a1a2e] p-6 rounded-xl border border-gray-800">
                    <div className="text-2xl font-bold text-[#9EFF00] mb-2">95%</div>
                    <div className="text-gray-300 text-sm">Satisfacción cliente</div>
                  </div>
                </div>

                <div className="space-y-4">
                  <h4 className="text-xl font-semibold text-white">Servicios Realizados:</h4>
                  <div className="flex flex-wrap gap-3">
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Packaging Design
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Identidad Visual
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Estrategia de Marca
                    </span>
                    <span className="px-4 py-2 bg-[#9EFF00]/10 text-[#9EFF00] rounded-full text-sm border border-[#9EFF00]/20">
                      Material POP
                    </span>
                  </div>
                </div>
              </div>

              <div className="order-1 lg:order-2">
                <div className="relative">
                  <img 
                    src={resolveLocal("https://readdy.ai/api/search-image?query=organic%20coffee%20packaging%20design%20with%20natural%20earth%20tones%2C%20eco-friendly%20sustainable%20branding%2C%20coffee%20beans%20and%20leaves%2C%20premium%20packaging%20materials%2C%20warm%20brown%20and%20green%20colors%2C%20artisanal%20coffee%20brand%20identity&width=600&height=500&seq=26&orientation=landscape")}
                    alt="Organic Café - Caso de éxito"
                    className="rounded-2xl object-cover object-top w-full h-[500px]"
                  />
                  <div className="absolute top-6 right-6 bg-[#9EFF00] text-black px-4 py-2 rounded-lg font-semibold">
                    Éxito Sostenible
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-16">
            <Button size="lg" href="#contacto">
              <i className="ri-rocket-line mr-2"></i>
              Crear Tu Caso de Éxito
            </Button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="nosotros" className="py-20 bg-[#0f0f23]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                ¿Por qué elegir <span className="text-[#9EFF00]">Rebranding</span>?
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Somos un equipo apasionado de diseñadores y estrategas que cree en el poder 
                transformador del <strong>branding</strong> y el <strong>diseño</strong>. 
                Cada proyecto es una oportunidad de crear algo extraordinario.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#9EFF00]/10 rounded-lg flex-shrink-0">
                    <i className="ri-award-line text-[#9EFF00] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Experiencia Comprobada</h3>
                    <p className="text-gray-300">Más de 200 proyectos exitosos en diversos sectores e industrias.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#9EFF00]/10 rounded-lg flex-shrink-0">
                    <i className="ri-team-line text-[#9EFF00] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Enfoque Colaborativo</h3>
                    <p className="text-gray-300">Trabajamos contigo en cada paso del proceso creativo.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#9EFF00]/10 rounded-lg flex-shrink-0">
                    <i className="ri-rocket-line text-[#9EFF00] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Resultados Medibles</h3>
                    <p className="text-gray-300">Nuestros diseños no solo se ven bien, también funcionan.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
                <img 
                src={resolveLocal("https://readdy.ai/api/search-image?query=creative%20design%20team%20working%20together%20in%20modern%20studio%2C%20diverse%20professionals%20collaborating%20on%20branding%20projects%2C%20computers%20with%20design%20software%2C%20color%20swatches%20and%20sketches%2C%20inspiring%20creative%20workspace%20atmosphere&width=600&height=500&seq=8&orientation=landscape")}
                alt="Equipo Rebranding trabajando"
                className="rounded-2xl object-cover object-top w-full h-[500px]"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#9EFF00] text-black p-6 rounded-2xl">
                <div className="text-3xl font-bold">200+</div>
                <div className="text-sm font-medium">Proyectos Exitosos</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      {/* Testimonials Section */}
      <section className="py-20 bg-[#1a1a2e]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Lo que dicen nuestros <span className="text-[#9EFF00]">clientes</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.name} className="bg-[#0f0f23] p-8 rounded-2xl border border-gray-800">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#9EFF00]"></i>
                  ))}
                </div>
                <p className="text-gray-300 mb-6 leading-relaxed">"{testimonial.text}"</p>
                <div>
                  <div className="font-semibold text-white">{testimonial.name}</div>
                  <div className="text-[#9EFF00] text-sm">{testimonial.company}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-20 bg-[#0f0f23]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              ¿Listo para transformar <span className="text-[#9EFF00]">tu marca</span>?
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Conversemos sobre tu proyecto. Estamos aquí para ayudarte a crear una marca 
              que destaque y genere resultados.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h3 className="text-2xl font-bold text-white mb-8">Información de Contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#9EFF00]/10 rounded-lg">
                    <i className="ri-mail-line text-[#9EFF00] text-xl"></i>
                  </div>
                  <div>
                    <div className="text-white font-medium">Email</div>
                    <div className="text-gray-300">hola@rebranding.cl</div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#9EFF00]/10 rounded-lg">
                    <i className="ri-phone-line text-[#9EFF00] text-xl"></i>
                  </div>
                  <div>
                    <div className="text-white font-medium">Teléfono</div>
                    <div className="text-gray-300">+56 9 1234 5678</div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#9EFF00]/10 rounded-lg">
                    <i className="ri-map-pin-line text-[#9EFF00] text-xl"></i>
                  </div>
                  <div>
                    <div className="text-white font-medium">Ubicación</div>
                    <div className="text-gray-300">Santiago, Chile</div>
                  </div>
                </div>
              </div>

              <div className="mt-12">
                <h4 className="text-xl font-semibold text-white mb-4">Síguenos</h4>
                <div className="flex space-x-4">
                  <a href="#" className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-[#9EFF00] text-gray-300 hover:text-black rounded-lg transition-all duration-200">
                    <i className="ri-instagram-line"></i>
                  </a>
                  <a href="#" className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-[#9EFF00] text-gray-300 hover:text-black rounded-lg transition-all duration-200">
                    <i className="ri-linkedin-line"></i>
                  </a>
                  <a href="#" className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-[#9EFF00] text-gray-300 hover:text-black rounded-lg transition-all duration-200">
                    <i className="ri-behance-line"></i>
                  </a>
                  <a href="#" className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-[#9EFF00] text-gray-300 hover:text-black rounded-lg transition-all duration-200">
                    <i className="ri-dribbble-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#1a1a2e] p-8 rounded-2xl border border-gray-800">
              <h3 className="text-2xl font-bold text-white mb-6">Cuéntanos sobre tu proyecto</h3>
              <p className="text-gray-300 mb-6">Prefieres contacto directo. Escríbenos por email o WhatsApp y coordinamos una reunión.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <a href="mailto:hola@rebranding.cl" className="inline-flex items-center justify-center px-4 py-3 bg-[#9EFF00] text-black rounded-lg font-semibold">
                  <i className="ri-mail-line mr-2"></i> Email
                </a>
                <a href="https://wa.me/56912345678?text=Hola%20Rebranding%2C%20tengo%20un%20proyecto" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center px-4 py-3 bg-gray-800 hover:bg-[#9EFF00] text-gray-300 hover:text-black rounded-lg font-semibold transition-colors">
                  <i className="ri-whatsapp-line mr-2"></i> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
